import MyHoursOverviewPageActionTypes from './my-hours-overview-page-action-types';

export const selectMyHoursOverviewPageTab = (tabIndex) => (dispatch) => {
  dispatch({ type: MyHoursOverviewPageActionTypes.SELECT_TAB, payload: { selectedTab: tabIndex } });
};
